import { useRef } from 'react';
import NewWindow from 'react-new-window';

export default function useWindow({ title, children, onWindowOpenUser, onUnload }) {

    const windowRef = useRef(null);

    function onWindowOpen(window) {
        windowRef.current = window;
        onWindowOpenUser();
    } 

    const component =
        <NewWindow title={title} onUnload={onUnload} onOpen={onWindowOpen}>
            {children}
        </NewWindow>

    return {windowRef, component}; 
} 